export default {
      id: "color_bacteria_old-usage",
      viewBox: "0 0 212 298",
      url: __webpack_public_path__ + "sprite.svg#color_bacteria_old",
      toString: function () {
        return this.url;
      }
    }